import { render, staticRenderFns } from "./ExamsView.vue?vue&type=template&id=28b8fa23&scoped=true"
import script from "./ExamsView.vue?vue&type=script&lang=js"
export * from "./ExamsView.vue?vue&type=script&lang=js"
import style0 from "./ExamsView.vue?vue&type=style&index=0&id=28b8fa23&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8fa23",
  null
  
)

export default component.exports